// Every IANA time zone an event may be anchored to, mirroring the backend's own list — see
// functions/external-calendars/util/timezones.js. The set is the zones CLDR maps to a Windows zone,
// because Microsoft Graph stores an event's zone as a Windows name and a handful of IANA zones have no
// mapping; the backend rejects those rather than silently moving the event, so offering one here would
// only produce a save that fails. Google would take any IANA name, but the picker is one control and a
// zone that worked on Google and not Outlook would fail for some users only, at save time.
//
// Includes the legacy spellings (Asia/Calcutta, Europe/Kiev, US/Pacific) alongside the modern ones so a
// zone an engine still reports under its old name is kept rather than filtered out.
//
// Generated from CLDR windowsZones.xml (release-47) + the tz database's `backward` links. Regenerate
// both sides together when tzdata adds a zone — until then a new zone is simply not offered, which is the
// safe direction to fail in.
// Countries are English-only because Hermes has no Intl.DisplayNames.
export const SUPPORTED_TIME_ZONES: ReadonlyMap<string, string> = new Map([
  ['Africa/Abidjan', 'Côte d’Ivoire'],
  ['Africa/Accra', 'Ghana'],
  ['Africa/Addis_Ababa', 'Ethiopia'],
  ['Africa/Algiers', 'Algeria'],
  ['Africa/Asmara', 'Eritrea'],
  ['Africa/Asmera', 'Eritrea'],
  ['Africa/Bamako', 'Mali'],
  ['Africa/Bangui', 'Central African Republic'],
  ['Africa/Banjul', 'Gambia'],
  ['Africa/Bissau', 'Guinea-Bissau'],
  ['Africa/Blantyre', 'Malawi'],
  ['Africa/Brazzaville', 'Congo - Brazzaville'],
  ['Africa/Bujumbura', 'Burundi'],
  ['Africa/Cairo', 'Egypt'],
  ['Africa/Casablanca', 'Morocco'],
  ['Africa/Ceuta', 'Spain'],
  ['Africa/Conakry', 'Guinea'],
  ['Africa/Dakar', 'Senegal'],
  ['Africa/Dar_es_Salaam', 'Tanzania'],
  ['Africa/Djibouti', 'Djibouti'],
  ['Africa/Douala', 'Cameroon'],
  ['Africa/El_Aaiun', 'Western Sahara'],
  ['Africa/Freetown', 'Sierra Leone'],
  ['Africa/Gaborone', 'Botswana'],
  ['Africa/Harare', 'Zimbabwe'],
  ['Africa/Johannesburg', 'South Africa'],
  ['Africa/Juba', 'South Sudan'],
  ['Africa/Kampala', 'Uganda'],
  ['Africa/Khartoum', 'Sudan'],
  ['Africa/Kigali', 'Rwanda'],
  ['Africa/Kinshasa', 'Congo - Kinshasa'],
  ['Africa/Lagos', 'Nigeria'],
  ['Africa/Libreville', 'Gabon'],
  ['Africa/Lome', 'Togo'],
  ['Africa/Luanda', 'Angola'],
  ['Africa/Lubumbashi', 'Congo - Kinshasa'],
  ['Africa/Lusaka', 'Zambia'],
  ['Africa/Malabo', 'Equatorial Guinea'],
  ['Africa/Maputo', 'Mozambique'],
  ['Africa/Maseru', 'Lesotho'],
  ['Africa/Mbabane', 'Eswatini'],
  ['Africa/Mogadishu', 'Somalia'],
  ['Africa/Monrovia', 'Liberia'],
  ['Africa/Nairobi', 'Kenya'],
  ['Africa/Ndjamena', 'Chad'],
  ['Africa/Niamey', 'Niger'],
  ['Africa/Nouakchott', 'Mauritania'],
  ['Africa/Ouagadougou', 'Burkina Faso'],
  ['Africa/Porto-Novo', 'Benin'],
  ['Africa/Sao_Tome', 'São Tomé & Príncipe'],
  ['Africa/Timbuktu', 'Mali'],
  ['Africa/Tripoli', 'Libya'],
  ['Africa/Tunis', 'Tunisia'],
  ['Africa/Windhoek', 'Namibia'],
  ['America/Adak', 'United States'],
  ['America/Anchorage', 'United States'],
  ['America/Anguilla', 'Anguilla'],
  ['America/Antigua', 'Antigua & Barbuda'],
  ['America/Araguaina', 'Brazil'],
  ['America/Argentina/Buenos_Aires', 'Argentina'],
  ['America/Argentina/Catamarca', 'Argentina'],
  ['America/Argentina/ComodRivadavia', 'Argentina'],
  ['America/Argentina/Cordoba', 'Argentina'],
  ['America/Argentina/Jujuy', 'Argentina'],
  ['America/Argentina/La_Rioja', 'Argentina'],
  ['America/Argentina/Mendoza', 'Argentina'],
  ['America/Argentina/Rio_Gallegos', 'Argentina'],
  ['America/Argentina/Salta', 'Argentina'],
  ['America/Argentina/San_Juan', 'Argentina'],
  ['America/Argentina/San_Luis', 'Argentina'],
  ['America/Argentina/Tucuman', 'Argentina'],
  ['America/Argentina/Ushuaia', 'Argentina'],
  ['America/Aruba', 'Aruba'],
  ['America/Asuncion', 'Paraguay'],
  ['America/Atikokan', 'Canada'],
  ['America/Atka', 'United States'],
  ['America/Bahia', 'Brazil'],
  ['America/Bahia_Banderas', 'Mexico'],
  ['America/Barbados', 'Barbados'],
  ['America/Belem', 'Brazil'],
  ['America/Belize', 'Belize'],
  ['America/Blanc-Sablon', 'Canada'],
  ['America/Boa_Vista', 'Brazil'],
  ['America/Bogota', 'Colombia'],
  ['America/Boise', 'United States'],
  ['America/Buenos_Aires', 'Argentina'],
  ['America/Cambridge_Bay', 'Canada'],
  ['America/Campo_Grande', 'Brazil'],
  ['America/Cancun', 'Mexico'],
  ['America/Caracas', 'Venezuela'],
  ['America/Catamarca', 'Argentina'],
  ['America/Cayenne', 'French Guiana'],
  ['America/Cayman', 'Cayman Islands'],
  ['America/Chicago', 'United States'],
  ['America/Chihuahua', 'Mexico'],
  ['America/Ciudad_Juarez', 'Mexico'],
  ['America/Coral_Harbour', 'Canada'],
  ['America/Cordoba', 'Argentina'],
  ['America/Costa_Rica', 'Costa Rica'],
  ['America/Coyhaique', 'Chile'],
  ['America/Creston', 'Canada'],
  ['America/Cuiaba', 'Brazil'],
  ['America/Curacao', 'Curaçao'],
  ['America/Danmarkshavn', 'Greenland'],
  ['America/Dawson', 'Canada'],
  ['America/Dawson_Creek', 'Canada'],
  ['America/Denver', 'United States'],
  ['America/Detroit', 'United States'],
  ['America/Dominica', 'Dominica'],
  ['America/Edmonton', 'Canada'],
  ['America/Eirunepe', 'Brazil'],
  ['America/El_Salvador', 'El Salvador'],
  ['America/Ensenada', 'Mexico'],
  ['America/Fort_Nelson', 'Canada'],
  ['America/Fort_Wayne', 'United States'],
  ['America/Fortaleza', 'Brazil'],
  ['America/Glace_Bay', 'Canada'],
  ['America/Godthab', 'Greenland'],
  ['America/Goose_Bay', 'Canada'],
  ['America/Grand_Turk', 'Turks & Caicos Islands'],
  ['America/Grenada', 'Grenada'],
  ['America/Guadeloupe', 'Guadeloupe'],
  ['America/Guatemala', 'Guatemala'],
  ['America/Guayaquil', 'Ecuador'],
  ['America/Guyana', 'Guyana'],
  ['America/Halifax', 'Canada'],
  ['America/Havana', 'Cuba'],
  ['America/Hermosillo', 'Mexico'],
  ['America/Indiana/Indianapolis', 'United States'],
  ['America/Indiana/Knox', 'United States'],
  ['America/Indiana/Marengo', 'United States'],
  ['America/Indiana/Petersburg', 'United States'],
  ['America/Indiana/Tell_City', 'United States'],
  ['America/Indiana/Vevay', 'United States'],
  ['America/Indiana/Vincennes', 'United States'],
  ['America/Indiana/Winamac', 'United States'],
  ['America/Indianapolis', 'United States'],
  ['America/Inuvik', 'Canada'],
  ['America/Iqaluit', 'Canada'],
  ['America/Jamaica', 'Jamaica'],
  ['America/Jujuy', 'Argentina'],
  ['America/Juneau', 'United States'],
  ['America/Kentucky/Louisville', 'United States'],
  ['America/Kentucky/Monticello', 'United States'],
  ['America/Knox_IN', 'United States'],
  ['America/Kralendijk', 'Caribbean Netherlands'],
  ['America/La_Paz', 'Bolivia'],
  ['America/Lima', 'Peru'],
  ['America/Los_Angeles', 'United States'],
  ['America/Louisville', 'United States'],
  ['America/Lower_Princes', 'Sint Maarten'],
  ['America/Maceio', 'Brazil'],
  ['America/Managua', 'Nicaragua'],
  ['America/Manaus', 'Brazil'],
  ['America/Marigot', 'St. Martin'],
  ['America/Martinique', 'Martinique'],
  ['America/Matamoros', 'Mexico'],
  ['America/Mazatlan', 'Mexico'],
  ['America/Mendoza', 'Argentina'],
  ['America/Menominee', 'United States'],
  ['America/Merida', 'Mexico'],
  ['America/Metlakatla', 'United States'],
  ['America/Mexico_City', 'Mexico'],
  ['America/Miquelon', 'St. Pierre & Miquelon'],
  ['America/Moncton', 'Canada'],
  ['America/Monterrey', 'Mexico'],
  ['America/Montevideo', 'Uruguay'],
  ['America/Montreal', 'Canada'],
  ['America/Montserrat', 'Montserrat'],
  ['America/Nassau', 'Bahamas'],
  ['America/New_York', 'United States'],
  ['America/Nipigon', 'Canada'],
  ['America/Nome', 'United States'],
  ['America/Noronha', 'Brazil'],
  ['America/North_Dakota/Beulah', 'United States'],
  ['America/North_Dakota/Center', 'United States'],
  ['America/North_Dakota/New_Salem', 'United States'],
  ['America/Nuuk', 'Greenland'],
  ['America/Ojinaga', 'Mexico'],
  ['America/Panama', 'Panama'],
  ['America/Pangnirtung', 'Canada'],
  ['America/Paramaribo', 'Suriname'],
  ['America/Phoenix', 'United States'],
  ['America/Port-au-Prince', 'Haiti'],
  ['America/Port_of_Spain', 'Trinidad & Tobago'],
  ['America/Porto_Acre', 'Brazil'],
  ['America/Porto_Velho', 'Brazil'],
  ['America/Puerto_Rico', 'Puerto Rico'],
  ['America/Punta_Arenas', 'Chile'],
  ['America/Rainy_River', 'Canada'],
  ['America/Rankin_Inlet', 'Canada'],
  ['America/Recife', 'Brazil'],
  ['America/Regina', 'Canada'],
  ['America/Resolute', 'Canada'],
  ['America/Rio_Branco', 'Brazil'],
  ['America/Rosario', 'Argentina'],
  ['America/Santa_Isabel', 'Mexico'],
  ['America/Santarem', 'Brazil'],
  ['America/Santiago', 'Chile'],
  ['America/Santo_Domingo', 'Dominican Republic'],
  ['America/Sao_Paulo', 'Brazil'],
  ['America/Scoresbysund', 'Greenland'],
  ['America/Shiprock', 'United States'],
  ['America/Sitka', 'United States'],
  ['America/St_Barthelemy', 'St. Barthélemy'],
  ['America/St_Johns', 'Canada'],
  ['America/St_Kitts', 'St. Kitts & Nevis'],
  ['America/St_Lucia', 'St. Lucia'],
  ['America/St_Thomas', 'U.S. Virgin Islands'],
  ['America/St_Vincent', 'St. Vincent & Grenadines'],
  ['America/Swift_Current', 'Canada'],
  ['America/Tegucigalpa', 'Honduras'],
  ['America/Thule', 'Greenland'],
  ['America/Thunder_Bay', 'Canada'],
  ['America/Tijuana', 'Mexico'],
  ['America/Toronto', 'Canada'],
  ['America/Tortola', 'British Virgin Islands'],
  ['America/Vancouver', 'Canada'],
  ['America/Virgin', 'U.S. Virgin Islands'],
  ['America/Whitehorse', 'Canada'],
  ['America/Winnipeg', 'Canada'],
  ['America/Yakutat', 'United States'],
  ['America/Yellowknife', 'Canada'],
  ['Antarctica/Casey', 'Antarctica'],
  ['Antarctica/Davis', 'Antarctica'],
  ['Antarctica/DumontDUrville', 'Antarctica'],
  ['Antarctica/Macquarie', 'Australia'],
  ['Antarctica/Mawson', 'Antarctica'],
  ['Antarctica/McMurdo', 'Antarctica'],
  ['Antarctica/Palmer', 'Antarctica'],
  ['Antarctica/Rothera', 'Antarctica'],
  ['Antarctica/South_Pole', 'Antarctica'],
  ['Antarctica/Syowa', 'Antarctica'],
  ['Antarctica/Vostok', 'Antarctica'],
  ['Arctic/Longyearbyen', 'Svalbard & Jan Mayen'],
  ['Asia/Aden', 'Yemen'],
  ['Asia/Almaty', 'Kazakhstan'],
  ['Asia/Amman', 'Jordan'],
  ['Asia/Anadyr', 'Russia'],
  ['Asia/Aqtau', 'Kazakhstan'],
  ['Asia/Aqtobe', 'Kazakhstan'],
  ['Asia/Ashgabat', 'Turkmenistan'],
  ['Asia/Ashkhabad', 'Turkmenistan'],
  ['Asia/Atyrau', 'Kazakhstan'],
  ['Asia/Baghdad', 'Iraq'],
  ['Asia/Bahrain', 'Bahrain'],
  ['Asia/Baku', 'Azerbaijan'],
  ['Asia/Bangkok', 'Thailand'],
  ['Asia/Barnaul', 'Russia'],
  ['Asia/Beirut', 'Lebanon'],
  ['Asia/Bishkek', 'Kyrgyzstan'],
  ['Asia/Brunei', 'Brunei'],
  ['Asia/Calcutta', 'India'],
  ['Asia/Chita', 'Russia'],
  ['Asia/Choibalsan', 'Mongolia'],
  ['Asia/Chongqing', 'China'],
  ['Asia/Chungking', 'China'],
  ['Asia/Colombo', 'Sri Lanka'],
  ['Asia/Dacca', 'Bangladesh'],
  ['Asia/Damascus', 'Syria'],
  ['Asia/Dhaka', 'Bangladesh'],
  ['Asia/Dili', 'Timor-Leste'],
  ['Asia/Dubai', 'United Arab Emirates'],
  ['Asia/Dushanbe', 'Tajikistan'],
  ['Asia/Famagusta', 'Cyprus'],
  ['Asia/Gaza', 'Palestinian Territories'],
  ['Asia/Harbin', 'China'],
  ['Asia/Hebron', 'Palestinian Territories'],
  ['Asia/Ho_Chi_Minh', 'Vietnam'],
  ['Asia/Hong_Kong', 'Hong Kong SAR China'],
  ['Asia/Hovd', 'Mongolia'],
  ['Asia/Irkutsk', 'Russia'],
  ['Asia/Istanbul', 'Türkiye'],
  ['Asia/Jakarta', 'Indonesia'],
  ['Asia/Jayapura', 'Indonesia'],
  ['Asia/Jerusalem', 'Israel'],
  ['Asia/Kabul', 'Afghanistan'],
  ['Asia/Kamchatka', 'Russia'],
  ['Asia/Karachi', 'Pakistan'],
  ['Asia/Kashgar', 'China'],
  ['Asia/Kathmandu', 'Nepal'],
  ['Asia/Katmandu', 'Nepal'],
  ['Asia/Khandyga', 'Russia'],
  ['Asia/Kolkata', 'India'],
  ['Asia/Krasnoyarsk', 'Russia'],
  ['Asia/Kuala_Lumpur', 'Malaysia'],
  ['Asia/Kuching', 'Malaysia'],
  ['Asia/Kuwait', 'Kuwait'],
  ['Asia/Macao', 'Macao SAR China'],
  ['Asia/Macau', 'Macao SAR China'],
  ['Asia/Magadan', 'Russia'],
  ['Asia/Makassar', 'Indonesia'],
  ['Asia/Manila', 'Philippines'],
  ['Asia/Muscat', 'Oman'],
  ['Asia/Nicosia', 'Cyprus'],
  ['Asia/Novokuznetsk', 'Russia'],
  ['Asia/Novosibirsk', 'Russia'],
  ['Asia/Omsk', 'Russia'],
  ['Asia/Oral', 'Kazakhstan'],
  ['Asia/Phnom_Penh', 'Cambodia'],
  ['Asia/Pontianak', 'Indonesia'],
  ['Asia/Pyongyang', 'North Korea'],
  ['Asia/Qatar', 'Qatar'],
  ['Asia/Qostanay', 'Kazakhstan'],
  ['Asia/Qyzylorda', 'Kazakhstan'],
  ['Asia/Rangoon', 'Myanmar (Burma)'],
  ['Asia/Riyadh', 'Saudi Arabia'],
  ['Asia/Saigon', 'Vietnam'],
  ['Asia/Sakhalin', 'Russia'],
  ['Asia/Samarkand', 'Uzbekistan'],
  ['Asia/Seoul', 'South Korea'],
  ['Asia/Shanghai', 'China'],
  ['Asia/Singapore', 'Singapore'],
  ['Asia/Srednekolymsk', 'Russia'],
  ['Asia/Taipei', 'Taiwan'],
  ['Asia/Tashkent', 'Uzbekistan'],
  ['Asia/Tbilisi', 'Georgia'],
  ['Asia/Tehran', 'Iran'],
  ['Asia/Tel_Aviv', 'Israel'],
  ['Asia/Thimbu', 'Bhutan'],
  ['Asia/Thimphu', 'Bhutan'],
  ['Asia/Tokyo', 'Japan'],
  ['Asia/Tomsk', 'Russia'],
  ['Asia/Ujung_Pandang', 'Indonesia'],
  ['Asia/Ulaanbaatar', 'Mongolia'],
  ['Asia/Ulan_Bator', 'Mongolia'],
  ['Asia/Urumqi', 'China'],
  ['Asia/Ust-Nera', 'Russia'],
  ['Asia/Vientiane', 'Laos'],
  ['Asia/Vladivostok', 'Russia'],
  ['Asia/Yakutsk', 'Russia'],
  ['Asia/Yangon', 'Myanmar (Burma)'],
  ['Asia/Yekaterinburg', 'Russia'],
  ['Asia/Yerevan', 'Armenia'],
  ['Atlantic/Azores', 'Portugal'],
  ['Atlantic/Bermuda', 'Bermuda'],
  ['Atlantic/Canary', 'Spain'],
  ['Atlantic/Cape_Verde', 'Cape Verde'],
  ['Atlantic/Faeroe', 'Faroe Islands'],
  ['Atlantic/Faroe', 'Faroe Islands'],
  ['Atlantic/Jan_Mayen', 'Svalbard & Jan Mayen'],
  ['Atlantic/Madeira', 'Portugal'],
  ['Atlantic/Reykjavik', 'Iceland'],
  ['Atlantic/South_Georgia', 'South Georgia & South Sandwich Islands'],
  ['Atlantic/St_Helena', 'St. Helena'],
  ['Atlantic/Stanley', 'Falkland Islands'],
  ['Australia/ACT', 'Australia'],
  ['Australia/Adelaide', 'Australia'],
  ['Australia/Brisbane', 'Australia'],
  ['Australia/Broken_Hill', 'Australia'],
  ['Australia/Canberra', 'Australia'],
  ['Australia/Currie', 'Australia'],
  ['Australia/Darwin', 'Australia'],
  ['Australia/Eucla', 'Australia'],
  ['Australia/Hobart', 'Australia'],
  ['Australia/LHI', 'Australia'],
  ['Australia/Lindeman', 'Australia'],
  ['Australia/Lord_Howe', 'Australia'],
  ['Australia/Melbourne', 'Australia'],
  ['Australia/NSW', 'Australia'],
  ['Australia/North', 'Australia'],
  ['Australia/Perth', 'Australia'],
  ['Australia/Queensland', 'Australia'],
  ['Australia/South', 'Australia'],
  ['Australia/Sydney', 'Australia'],
  ['Australia/Tasmania', 'Australia'],
  ['Australia/Victoria', 'Australia'],
  ['Australia/West', 'Australia'],
  ['Australia/Yancowinna', 'Australia'],
  ['Brazil/Acre', 'Brazil'],
  ['Brazil/DeNoronha', 'Brazil'],
  ['Brazil/East', 'Brazil'],
  ['Brazil/West', 'Brazil'],
  ['CET', ''],
  ['Canada/Atlantic', 'Canada'],
  ['Canada/Central', 'Canada'],
  ['Canada/Eastern', 'Canada'],
  ['Canada/Mountain', 'Canada'],
  ['Canada/Newfoundland', 'Canada'],
  ['Canada/Pacific', 'Canada'],
  ['Canada/Saskatchewan', 'Canada'],
  ['Canada/Yukon', 'Canada'],
  ['Chile/Continental', 'Chile'],
  ['Chile/EasterIsland', 'Chile'],
  ['Cuba', 'Cuba'],
  ['EET', ''],
  ['EST', ''],
  ['Egypt', 'Egypt'],
  ['Eire', 'Ireland'],
  ['Etc/GMT', ''],
  ['Etc/GMT+0', ''],
  ['Etc/GMT+1', ''],
  ['Etc/GMT+10', ''],
  ['Etc/GMT+11', ''],
  ['Etc/GMT+12', ''],
  ['Etc/GMT+2', ''],
  ['Etc/GMT+3', ''],
  ['Etc/GMT+4', ''],
  ['Etc/GMT+5', ''],
  ['Etc/GMT+6', ''],
  ['Etc/GMT+7', ''],
  ['Etc/GMT+8', ''],
  ['Etc/GMT+9', ''],
  ['Etc/GMT-0', ''],
  ['Etc/GMT-1', ''],
  ['Etc/GMT-10', ''],
  ['Etc/GMT-11', ''],
  ['Etc/GMT-12', ''],
  ['Etc/GMT-13', ''],
  ['Etc/GMT-14', ''],
  ['Etc/GMT-2', ''],
  ['Etc/GMT-3', ''],
  ['Etc/GMT-4', ''],
  ['Etc/GMT-5', ''],
  ['Etc/GMT-6', ''],
  ['Etc/GMT-7', ''],
  ['Etc/GMT-8', ''],
  ['Etc/GMT-9', ''],
  ['Etc/GMT0', ''],
  ['Etc/Greenwich', ''],
  ['Etc/UCT', ''],
  ['Etc/UTC', ''],
  ['Etc/Universal', ''],
  ['Etc/Zulu', ''],
  ['Europe/Amsterdam', 'Netherlands'],
  ['Europe/Andorra', 'Andorra'],
  ['Europe/Astrakhan', 'Russia'],
  ['Europe/Athens', 'Greece'],
  ['Europe/Belfast', 'United Kingdom'],
  ['Europe/Belgrade', 'Serbia'],
  ['Europe/Berlin', 'Germany'],
  ['Europe/Bratislava', 'Slovakia'],
  ['Europe/Brussels', 'Belgium'],
  ['Europe/Bucharest', 'Romania'],
  ['Europe/Budapest', 'Hungary'],
  ['Europe/Busingen', 'Germany'],
  ['Europe/Chisinau', 'Moldova'],
  ['Europe/Copenhagen', 'Denmark'],
  ['Europe/Dublin', 'Ireland'],
  ['Europe/Gibraltar', 'Gibraltar'],
  ['Europe/Guernsey', 'Guernsey'],
  ['Europe/Helsinki', 'Finland'],
  ['Europe/Isle_of_Man', 'Isle of Man'],
  ['Europe/Istanbul', 'Türkiye'],
  ['Europe/Jersey', 'Jersey'],
  ['Europe/Kaliningrad', 'Russia'],
  ['Europe/Kiev', 'Ukraine'],
  ['Europe/Kirov', 'Russia'],
  ['Europe/Kyiv', 'Ukraine'],
  ['Europe/Lisbon', 'Portugal'],
  ['Europe/Ljubljana', 'Slovenia'],
  ['Europe/London', 'United Kingdom'],
  ['Europe/Luxembourg', 'Luxembourg'],
  ['Europe/Madrid', 'Spain'],
  ['Europe/Malta', 'Malta'],
  ['Europe/Mariehamn', 'Åland Islands'],
  ['Europe/Minsk', 'Belarus'],
  ['Europe/Monaco', 'Monaco'],
  ['Europe/Moscow', 'Russia'],
  ['Europe/Nicosia', 'Cyprus'],
  ['Europe/Oslo', 'Norway'],
  ['Europe/Paris', 'France'],
  ['Europe/Podgorica', 'Montenegro'],
  ['Europe/Prague', 'Czechia'],
  ['Europe/Riga', 'Latvia'],
  ['Europe/Rome', 'Italy'],
  ['Europe/Samara', 'Russia'],
  ['Europe/San_Marino', 'San Marino'],
  ['Europe/Sarajevo', 'Bosnia & Herzegovina'],
  ['Europe/Saratov', 'Russia'],
  ['Europe/Simferopol', 'Ukraine'],
  ['Europe/Skopje', 'North Macedonia'],
  ['Europe/Sofia', 'Bulgaria'],
  ['Europe/Stockholm', 'Sweden'],
  ['Europe/Tallinn', 'Estonia'],
  ['Europe/Tirane', 'Albania'],
  ['Europe/Tiraspol', 'Moldova'],
  ['Europe/Ulyanovsk', 'Russia'],
  ['Europe/Uzhgorod', 'Ukraine'],
  ['Europe/Vaduz', 'Liechtenstein'],
  ['Europe/Vatican', 'Vatican City'],
  ['Europe/Vienna', 'Austria'],
  ['Europe/Vilnius', 'Lithuania'],
  ['Europe/Volgograd', 'Russia'],
  ['Europe/Warsaw', 'Poland'],
  ['Europe/Zagreb', 'Croatia'],
  ['Europe/Zaporozhye', 'Ukraine'],
  ['Europe/Zurich', 'Switzerland'],
  ['GB', 'United Kingdom'],
  ['GB-Eire', 'United Kingdom'],
  ['GMT+0', ''],
  ['GMT-0', ''],
  ['GMT0', ''],
  ['Greenwich', ''],
  ['HST', ''],
  ['Hongkong', 'Hong Kong SAR China'],
  ['Iceland', 'Iceland'],
  ['Indian/Antananarivo', 'Madagascar'],
  ['Indian/Chagos', 'British Indian Ocean Territory'],
  ['Indian/Christmas', 'Christmas Island'],
  ['Indian/Cocos', 'Cocos (Keeling) Islands'],
  ['Indian/Comoro', 'Comoros'],
  ['Indian/Kerguelen', 'French Southern Territories'],
  ['Indian/Mahe', 'Seychelles'],
  ['Indian/Maldives', 'Maldives'],
  ['Indian/Mauritius', 'Mauritius'],
  ['Indian/Mayotte', 'Mayotte'],
  ['Indian/Reunion', 'Réunion'],
  ['Iran', 'Iran'],
  ['Israel', 'Israel'],
  ['Jamaica', 'Jamaica'],
  ['Japan', 'Japan'],
  ['Kwajalein', 'Marshall Islands'],
  ['Libya', 'Libya'],
  ['MET', ''],
  ['MST', ''],
  ['Mexico/BajaNorte', 'Mexico'],
  ['Mexico/BajaSur', 'Mexico'],
  ['Mexico/General', 'Mexico'],
  ['NZ', 'New Zealand'],
  ['NZ-CHAT', 'New Zealand'],
  ['Navajo', 'United States'],
  ['PRC', 'China'],
  ['Pacific/Apia', 'Samoa'],
  ['Pacific/Auckland', 'New Zealand'],
  ['Pacific/Bougainville', 'Papua New Guinea'],
  ['Pacific/Chatham', 'New Zealand'],
  ['Pacific/Chuuk', 'Micronesia'],
  ['Pacific/Easter', 'Chile'],
  ['Pacific/Efate', 'Vanuatu'],
  ['Pacific/Enderbury', 'Kiribati'],
  ['Pacific/Fakaofo', 'Tokelau'],
  ['Pacific/Fiji', 'Fiji'],
  ['Pacific/Funafuti', 'Tuvalu'],
  ['Pacific/Galapagos', 'Ecuador'],
  ['Pacific/Gambier', 'French Polynesia'],
  ['Pacific/Guadalcanal', 'Solomon Islands'],
  ['Pacific/Guam', 'Guam'],
  ['Pacific/Honolulu', 'United States'],
  ['Pacific/Johnston', 'U.S. Outlying Islands'],
  ['Pacific/Kanton', 'Kiribati'],
  ['Pacific/Kiritimati', 'Kiribati'],
  ['Pacific/Kosrae', 'Micronesia'],
  ['Pacific/Kwajalein', 'Marshall Islands'],
  ['Pacific/Majuro', 'Marshall Islands'],
  ['Pacific/Marquesas', 'French Polynesia'],
  ['Pacific/Midway', 'U.S. Outlying Islands'],
  ['Pacific/Nauru', 'Nauru'],
  ['Pacific/Niue', 'Niue'],
  ['Pacific/Norfolk', 'Norfolk Island'],
  ['Pacific/Noumea', 'New Caledonia'],
  ['Pacific/Pago_Pago', 'American Samoa'],
  ['Pacific/Palau', 'Palau'],
  ['Pacific/Pitcairn', 'Pitcairn Islands'],
  ['Pacific/Pohnpei', 'Micronesia'],
  ['Pacific/Ponape', 'Micronesia'],
  ['Pacific/Port_Moresby', 'Papua New Guinea'],
  ['Pacific/Rarotonga', 'Cook Islands'],
  ['Pacific/Saipan', 'Northern Mariana Islands'],
  ['Pacific/Samoa', 'American Samoa'],
  ['Pacific/Tahiti', 'French Polynesia'],
  ['Pacific/Tarawa', 'Kiribati'],
  ['Pacific/Tongatapu', 'Tonga'],
  ['Pacific/Truk', 'Micronesia'],
  ['Pacific/Wake', 'U.S. Outlying Islands'],
  ['Pacific/Wallis', 'Wallis & Futuna'],
  ['Pacific/Yap', 'Micronesia'],
  ['Poland', 'Poland'],
  ['Portugal', 'Portugal'],
  ['ROC', 'Taiwan'],
  ['ROK', 'South Korea'],
  ['Singapore', 'Singapore'],
  ['Turkey', 'Türkiye'],
  ['UCT', ''],
  ['US/Alaska', 'United States'],
  ['US/Aleutian', 'United States'],
  ['US/Arizona', 'United States'],
  ['US/Central', 'United States'],
  ['US/East-Indiana', 'United States'],
  ['US/Eastern', 'United States'],
  ['US/Hawaii', 'United States'],
  ['US/Indiana-Starke', 'United States'],
  ['US/Michigan', 'United States'],
  ['US/Mountain', 'United States'],
  ['US/Pacific', 'United States'],
  ['US/Samoa', 'American Samoa'],
  ['UTC', ''],
  ['Universal', ''],
  ['W-SU', 'Russia'],
  ['WET', ''],
  ['Zulu', ''],
]);
